import React, { useCallback } from 'react';
import { useBulkOpsSessionContext } from '@atlassian/jira-bulk-operations-analytics/src/controllers/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import {
	useFormStatusFlags,
	type FlagRendererProps,
} from '../../controllers/use-form-submit-state/utils.tsx';
import { OperationErrorFlag } from './flags/error-flag/index.tsx';
import { InProgressFlag } from './flags/in-progress-flag/index.tsx';
import { OperationPartialErrorFlag } from './flags/partial-error-flag/index.tsx';
import { OperationSuccessFlag } from './flags/success-flag/index.tsx';

export const useEditFormStatusFlags = () => {
	// on clean up remove bulkOpsFlow completely
	const bulkOpsFlow = fg('dee-7206-add-bulk-ops-type-to-analytics')
		? undefined
		: // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
			useBulkOpsSessionContext();

	const renderInProgressFlag = useCallback(
		(props: FlagRendererProps) => <InProgressFlag {...props} />,
		[],
	);
	const renderSuccessFlag = useCallback(
		(props: FlagRendererProps) => <OperationSuccessFlag {...props} bulkOpsFlow={bulkOpsFlow} />,
		[bulkOpsFlow],
	);
	const renderErrorFlag = useCallback(
		(props: FlagRendererProps) => <OperationErrorFlag {...props} bulkOpsFlow={bulkOpsFlow} />,
		[bulkOpsFlow],
	);
	const renderPartialErrorFlag = useCallback(
		(props: FlagRendererProps) => (
			<OperationPartialErrorFlag {...props} bulkOpsFlow={bulkOpsFlow} />
		),
		[bulkOpsFlow],
	);
	useFormStatusFlags({
		renderInProgressFlag,
		renderSuccessFlag,
		renderErrorFlag,
		renderPartialErrorFlag,
	});
};
